<template>
  <div
      class="text-danger input-error-text"
      v-if="formErrors.has(forItem)">
    <span v-if="regexError || numericOnly">
      {{fieldName}} is invalid
    </span>
    <span v-else-if="maxLengthExceeded">
       {{fieldName}} cannot exceed {{maxLength}} characters
    </span>
    <span v-else-if="minLengthRequired">
      {{fieldName}} must be at least {{minLength}} characters
    </span>
    <span v-else-if="costCenterMismatch">
      Cost center is not matching with the company code "{{costCenterPrefix}}", please correct the cost center.
    </span>
    <span v-else>
      {{fieldName ? fieldName : 'This field'}} is required
    </span>
  </div>
</template>

<script>

export default {
  name: "ShowErrors",
  props: [
      'forItem',
      'formErrors',
      'maxLength',
      'minLength',
      'fieldName',
      'costCenterPrefix'],
  computed: {
    maxLengthExceeded() {
      let errors = this.formErrors.items.find(errors => errors.field === this.forItem)
      return errors.rule === "max"
    },
    minLengthRequired() {
      let errors = this.formErrors.items.find(errors => errors.field === this.forItem)
      return errors.rule === "min"
    },
    regexError() {
      let errors = this.formErrors.items.find(errors => errors.field === this.forItem)
      return errors.rule === "regex"
    },
    costCenterMismatch() {
      let errors = this.formErrors.items.find(errors => errors.field === this.forItem)
      return errors.rule === "costCenterRule"
    },
    numericOnly() {
      let errors = this.formErrors.items.find(errors => errors.field === this.forItem)
      return errors.rule === "numeric"
    }
  }
}
</script>

<style scoped>

</style>